import { render, staticRenderFns } from "./RoleDetailView.vue?vue&type=template&id=5823de5d&scoped=true"
import script from "./RoleDetailView.vue?vue&type=script&lang=js"
export * from "./RoleDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823de5d",
  null
  
)

export default component.exports